import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Instalacion/addInstalacion`, method: 'POST', body: values, token: token})
}
